<ng-container *ngIf="showHeader">
  <ui-message [type]="'info'">{{ 'orderProcess.payment.payInStorePayment.note' | translate }}</ui-message>
  <div class="d-flex mt-5 mb-4 flex-column align-items-start flex-lg-row align-items-lg-end mt-2">
    <h4 class="me-2 mb-0">{{ 'orderProcess.payment.contactForm.title' | translate }}</h4>
    <div class="text-primary cursor-pointer font-md d-none d-sm-block"
         [translate]="'orderProcess.payment.whyDoAskInfo.question'"
         ngbTooltip="{{'orderProcess.payment.whyDoAskInfo.answer' | translate}}">
    </div>
  </div>
</ng-container>

<payment-contact-info
  [userInfo]="info"
  [countryCode]="countryCode"
  [personType]="personType"
  [askForReferenceField]="personType === PAYMENT_PERSON_TYPES.COMPANY"
  (onInfoUpdated)="onInfoUpdated($event)"
  (onValidUpdated)="isValid = $event"
></payment-contact-info>
<div>
  <div class="mt-4 mb-4">
    <ui-newsletter-signup
      class="d-block mb-3"
      *ngIf="!alreadySubscriber"
      [isSubscribe]="info?.subscribedOnNews"
      (onChange)="newsletterUpdate($event)"
    ></ui-newsletter-signup>
  </div>
  <button class="btn btn-pink btn-xl"
          [disabled]="!isValid || loading"
          (click)="submit()">
    {{ 'common.confirm' | translate }}
  </button>

  <terms-and-conditions class="d-block mt-3"
                        (onTermsClick)="onTermsClick.emit()">
  </terms-and-conditions>
</div>
